module.exports = __webpack_public_path__ + "img/1554386268.ad957f90.jpg";